import { observer } from "@legendapp/state/react";
import { createRef, RefObject, Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InlineLoader from "../../../components/ui/inline-loader/InlineLoader";
import OverlayLoader from "../../../components/ui/overlay-loader/OverlayLoader";
import Overlay from "../../../components/ui/overlay/Overlay";
import { useQueryGetDocumentContent } from "../../../query/getDocumentContent/getDocumentContent.query";
import { overlayState$ } from "../../../state";

const CategoryOverlay = observer(() => {

    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [isVisible, setIsVisible] = useState(false);
    const element: RefObject<HTMLDivElement> = createRef();

    const currentOverlayActiveId = overlayState$.activeItemId.get();
    const { data: overlayContent, isLoading, isError } = useQueryGetDocumentContent(!!currentOverlayActiveId, currentOverlayActiveId || '');

    useEffect(() => {
        if (!currentOverlayActiveId) {
            document.body.classList.remove('overlay--opened');
        } else {
            document.body.classList.add('overlay--opened');
        }
    }, [currentOverlayActiveId])
    useEffect(() => {
        if (!isLoading && overlayContent && currentOverlayActiveId) {
            setIsVisible(true);
        }
    }, [currentOverlayActiveId, isLoading])

    useEffect(() => {

        return () => {
            if (overlayContent?.content) {
                URL.revokeObjectURL(overlayContent?.content);
            }
        };
    }, [overlayContent?.content]);

    if (isLoading) {
        return <OverlayLoader />
    }

    if (isError) {
        return null
    }

    return (
        <Suspense fallback={<OverlayLoader />}>

            <Overlay ref={element} requestClose={handleClose} isVisible={isVisible}>
                <h2 className="overlay__title">
                    {overlayContent ? overlayContent.title : <InlineLoader />}
                </h2>

                {
                    overlayContent ?
                        <div className="overlay-iframe">
                            <iframe src={overlayContent.content} title={overlayContent.title} width={'100%'} height={'100%'} />
                        </div> : <InlineLoader />
                }
            </Overlay>

        </Suspense>
    )

    async function handleClose() {
        setIsVisible(false);
        document.body.classList.remove('overlay--opened');
        // await new Promise(resolve => {
        //     setTimeout(() => {
        //         return resolve(true)
        //     }, 500)
        // })

        overlayState$.activeItem.set(null);
        overlayState$.activeItemId.set(null);
        return navigate({
            pathname: pathname
            //pathname: pathname.slice(0, pathname.lastIndexOf('/')),
        })
    }
})

export default CategoryOverlay;
